// extracted by mini-css-extract-plugin
export default {"main":"LogOut_main__1AJxb","boxContainer":"LogOut_boxContainer__Oy28z","okBtn":"LogOut_okBtn__CkNrL","noBtn":"LogOut_noBtn__-9ZfU"};